import React from 'react';


import { TextInput } from './text-input';
import type { TextInputProps } from './text-input';

import { reinterpretAsCents } from '@/utils/format-money';

const DISPLAY_RE = /^(-?)(\d+)(\.\d{2})?$/;

const formatWithCommas = (dollarString: string): string => {
	const m = dollarString.match(DISPLAY_RE);
	if (!m) return dollarString;
	const sign = m[1] ?? '';
	const intPart = m[2] ?? '';
	const dec = m[3] ?? '';
	const grouped = intPart.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
	return sign + grouped + dec;
};

/**
 * Money input that interprets typed digits as integer cents
 * (e.g. typing `14119` produces `141.19`). Decimal points are ignored —
 * they're inserted automatically two places from the right. Display shows
 * thousands separators; the `onChangeText` payload is a plain dollar
 * string ready for `parseMoneyToCents` on submit.
 */
export const MoneyTextInput: React.FC<TextInputProps> = ({ value, onChangeText, keyboardType, ...rest }) => {
	const dollarString = reinterpretAsCents(typeof value === 'string' ? value : undefined);
	return (
		<TextInput
			{...rest}
			keyboardType={keyboardType ?? 'decimal-pad'}
			value={formatWithCommas(dollarString)}
			onChangeText={(s) => onChangeText?.(reinterpretAsCents(s))}
		/>
	);
};
